const productReducer = (state, action) => {
    switch (action.type) {
        case 'GET_OILS':
            return {
                ...state,
                oils: action.payload,
                loading: false
            }
        case 'GET_OIL':
            return {
                ...state,
                oil: action.payload,
                loading: false
            }
        case 'GET_ADDITIVE':
            return {
                ...state,
                additive: action.payload,
                loading: false
            }
        case 'GET_RELATED_PRODUCTS':
            return {
                ...state,
                relatedProducts: action.payload,
                loading: false
            }
        case 'SET_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'SET_TOTAL_PAGES':
            return {
                ...state,
                totalPages: action.payload
            }
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.payload
            }
        case 'SET_CART_ITEMS':
            return {
                ...state,
                cartItems: action.payload
            }
        case 'GET_FILTER':
            return {
                ...state,
                filter: action.payload,
                loading: false
            }
        case 'GET_SEARCHED_PRODUCTS':
            return {
                ...state,
                searchedProducts: action.payload,
                loading: false
            }
        case 'SET_SEARCHED_NAME':
            return {
                ...state,
                searchedName: action.payload
            }
        case 'GET_CAR_NAME':
            return {
                ...state,
                carName: action.payload
            }
        case 'SET_CAR_NAME':
            return {
                ...state,
                carName: action.payload
            }
        default:
            return state
    }
}

export default productReducer